import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from "@rails/request.js"

export default class extends Controller {
  static targets = ["input", "background"]
  
  // Define values with configuration options
  static values = {
    shouldUpdate: { type: Boolean, default: true },
  }

  connect() {
    const activeInput = this.inputTargets.find(input => input.classList.contains('active'))
    if (activeInput) {
      const index = this.inputTargets.indexOf(activeInput)
      this.updateBackgroundPosition(index)
    }
  }

  activateView(event) {
    const clickedFormat = event.currentTarget.dataset.format
    this.inputTargets.forEach(link => {
      link.classList.remove('active', 'hover:cursor-not-allowed')
    })
    event.currentTarget.classList.add('active', 'hover:cursor-not-allowed');
    
    const isCurrentView = event.currentTarget.classList.contains("cursor-not-allowed")
    if (isCurrentView) {
      event.preventDefault()
    }
    const index = parseInt(event.currentTarget.dataset.index)
    this.updateBackgroundPosition(index)
    this.shouldUpdateValue ? this.updateCustomerSetting(clickedFormat) : false;
  }

  updateBackgroundPosition(index = 0) {
    const activeInput = this.inputTargets[index]
    const width = activeInput.offsetWidth
    const containerWidth = this.element.offsetWidth
    const widthPercentage = (width / containerWidth) * 100
    
    this.backgroundTarget.style.width = `${widthPercentage}%`
    
    const offsetLeft = activeInput.offsetLeft
    
    this.backgroundTarget.style.transform = `translateX(${offsetLeft}px)`
  }

  toggleButtonStyle(button) {
    this.viewTargets.forEach(target => {
      target.classList.toggle('bg-blue-300')
      target.classList.toggle('text-white')
      target.classList.toggle('hover:bg-blue-300')
      target.classList.toggle('hover:text-white')
      target.classList.toggle('active')
    })
  }

  async updateCustomerSetting(viewFormat) {
    const request = new FetchRequest("patch", "/customer", {
      body: {
        customer: {
          view_format: viewFormat
        }
      },
      responseKind: "json"
    })
    
    try {
      const response = await request.perform()
      if (!response.ok) {
        console.error('Failed to update customer setting')
      }
    } catch (error) {
      console.error('Error updating customer setting:', error)
    }
  }
}